(ns nosco.colors
  #?(:clj (:require
           [clojure.string :as string]
           [nosco.figma-utils :refer [defmap]])
     :cljs (:require-macros [nosco.figma-utils :refer [defmap]])))

(defmap colors
  {blue-50 "#EFF4FE"
   blue-100 "#E5EEFF"
   blue-200 "#CDDEFF"
   blue-300 "#B1CBFC"
   blue-400 "#8DAEFC"
   blue-500 "#5083FA"
   blue-600 "#3D73F2"
   blue-700 "#2E65E5"
   blue-800 "#2959CC"
   blue-900 "#050E54"

   green-50 "#EAFBF4"
   green-100 "#B4ECCD"
   green-200 "#7DDFAD"
   green-300 "#28D28C"
   green-400 "#27C486"
   green-500 "#20BA87"
   green-600 "#1AAB7B"
   green-700 "#0F996B"
   green-800 "#07875C"
   green-900 "#056746"

   neutral-10 "#F6F7F8"
   neutral-20 "#F0F2F5"
   neutral-100 "#E4E6EB"
   neutral-200 "#D7DAE0"
   neutral-300 "#C0C3CC"
   neutral-400 "#878B99"
   neutral-500 "#72778A"
   neutral-600 "#606378"
   neutral-700 "#474B5E"
   neutral-800 "#36394D"
   neutral-900 "#26273B"

   white "#FFFFFF"

   data-beige "#F5E6AA"
   data-blue "#3D73F2"
   data-green "#28D28C"
   data-navy "#050F55"
   data-orange "#D6731C"
   data-purple "#7D5AC3"
   data-red "#F0286B"
   data-turquoise "#2ED2B9"
   data-violet "#4618A1"
   data-yellow "#FFBD41"

   info-50 "#EFEAF8"
   info-100 "#D1C5E9"
   info-300 "#A891D7"
   info-400 "#7D5AC3"
   info-500 "#663EB8"
   info-600 "#5D39B2"
   info-800 "#442BA1"

   error-50 "#FFF7F9"
   error-100 "#FABDD3"
   error-300 "#F56798"
   error-400 "#F24681"
   error-500 "#F0286B"
   error-600 "#DF2567"
   error-800 "#B31D5E"

   success-50 "#E7F8F3"
   success-100 "#B9E4D1"
   success-300 "#53C397"
   success-400 "#11B683"
   success-500 "#00A96C"
   success-600 "#009A61"
   success-800 "#007748"

   warning-50 "#FEF8E4"
   warning-100 "#FDEAB3"
   warning-300 "#FBD14F"
   warning-400 "#FAC62A"
   warning-500 "#F9AF08"
   warning-700 "#F99C07"
   warning-900 "#9F4F09"

   heatmap-green "#5BBA8B"
   heatmap-yellow "#FED86F"
   heatmap-red "#DE6768"})

(def data-colors
  [data-beige
   data-blue
   data-green
   data-navy
   data-orange
   data-purple
   data-red
   data-turquoise
   data-violet
   data-yellow])

(defn data-color-for
  "Returns the same color each time for `seed` (nil-safe)."
  [seed]
  (nth data-colors (mod (hash seed) (count data-colors))))

(def border-secondary neutral-300)
(def border-primary neutral-100)
(def fill-secondary neutral-20)
(def border-success success-600)
(def border-error error-500)
(def border-warning warning-700)
(def text-primary neutral-900)

(def icon-success success-600)
(def icon-error error-600)
(def icon-warning warning-700)

#?(:clj (defn- colors-scss []
          (let [colors* (sort-by key colors)]
            (str
             "// GENERATED BY nosco.colors\n\n"
             (->> colors*
                  (map (fn [[k v]] (format "$color-%s: %s;" k v)))
                  (string/join "\n"))
             "\n\n"
             "$nosco-colors: (\n"
             (->> colors*
                  (map (fn [[k _v]] (format "  \"%s\": $color-%s" k k)))
                  (string/join ",\n"))
             "\n);"))))

#?(:clj (defn export-colors-to-scss! [output-path]
          (spit output-path (str (colors-scss) "\n"))))

(comment

  (export-colors-to-scss! "scss/_colors.scss"))
